import {
  buildBusinessUpdateMediaUrl,
  BUSINESS_UPDATE_MEDIA_KEY_PREFIX,
} from '@afriex/core/utils';

import {VITE_PUBLIC_API_BASE_URL} from '@/config/endpoints';

import {businessUpdateService} from './businessUpdateService';

const ALLOWED_IMAGE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
];
const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Uploads an update image and returns the media-route URL to use as its `src`. */
export const uploadBusinessUpdateImage = async (
  file: File,
): Promise<string> => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error('Only PNG, JPEG, GIF or WebP images can be uploaded');
  }
  if (file.size > MAX_IMAGE_BYTES) {
    throw new Error('Images must be 5 MB or smaller');
  }
  const ext =
    file.type === 'image/jpeg' ? 'jpg' : file.type.slice('image/'.length);
  const key = `${BUSINESS_UPDATE_MEDIA_KEY_PREFIX}${crypto.randomUUID()}.${ext}`;

  const {url: uploadUrl} = await businessUpdateService.presignMedia(key);

  const putResponse = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {'Content-Type': file.type},
  });
  if (!putResponse.ok) {
    throw new Error(`Failed to upload image (status ${putResponse.status})`);
  }

  return buildBusinessUpdateMediaUrl(VITE_PUBLIC_API_BASE_URL, key);
};
